<app-header-one [sticky]="false"></app-header-one>
<router-outlet></router-outlet>
<app-footer-one></app-footer-one>
